import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { DateValue, PickerPanelType, DateMode } from '../../interface';

interface IProps {
    info: Dayjs;
    dateFormat: string;
    isMultiple?: boolean; // 是否多选
    value?: [DateValue, DateValue];
    selectIndex: PickerPanelType;
    mode?: DateMode;
    disabledDate?: (date: Dayjs) => boolean;
}

const RenderDay = (props: IProps) => {
    const { info, value = [], dateFormat, mode = DateMode.multiple, selectIndex, disabledDate } = props;
    const isSignal = mode === DateMode.signal;

    const getRenderDayCls = () => {
        let result = 'render-day';
        const isSelectStart = selectIndex === PickerPanelType.start;
        const isSelectEnd = selectIndex === PickerPanelType.end;
        const currentDate = info.format(dateFormat);
        if (value?.[0]) {
            const startDate = dayjs(value[0]).format(dateFormat);

            if ((info.isBefore(value[0]) && isSelectEnd && !isSignal) || disabledDate?.(info)) {
                result += ' disabled';
            }
            if (currentDate === startDate) {
                result += ' render-start-selected selected';
            }
        }
        if (value?.[1]) {
            const endDate = dayjs(value[1]).format(dateFormat);
            if ((info.isAfter(value[1]) && isSelectStart && !isSignal) || disabledDate?.(info)) {
                result += ' disabled';
            }
            if (endDate === currentDate) {
                result += ' render-selected-end selected';
            }
        }
        if (value?.[0] && value?.[1]) {
            if (info.isAfter(value[0]) && info.isBefore(value[1])) {
                result += ' render-day-range';
            }
        }
        return result;
    };
    return <div className={getRenderDayCls()}>{info.date()}</div>;
};

export { RenderDay };
